import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import classNames from 'classnames';
import classes from './Menu.scss';
import config from 'cityads-v3/config';
import { useTheme } from '@material-ui/core'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';
import UserdocsLink from 'cityads-v3/components/Links/UserdocsLink';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import { RootState } from 'cityads-v3/types/reducer';

export default function MenuBottomLinks(): JSX.Element {
  const { t } = useTranslation(['main'])
  const docked = useSelector((state: RootState) => state.menu.docked)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)
  const isBlogger = useSelector((state: RootState) => state.auth.user?.isBlogger)

  const theme = useTheme()
  const isDark = theme.palette.type === 'dark';

  if (isBlogger) {
    return null
  }

  return (
    <div className={classes.bottomLinks}>
      <List dense={true}>

        <Tooltip
          isLight
          enabled={!docked}
          enterDelay={config.TOOLTIP_DELAY}
          title={t('documentation')}
          disableFocusListener={true}
          placement="right"
        >
          <ListItem
            button
            component={UserdocsLink}
            href={'/'}
            classes={{
              root: classes.menuItemLink,
            }}
          >
            <ListItemIcon classes={{
              root: classNames({
                [classes.menuItemIcon]: !docked && !isMobile,
                [classes.dockedMenuItemIcon]: docked && !isMobile,
              })
            }}>
              <InfoOutlinedIcon />
            </ListItemIcon>
            {(docked || isMobile) && <ListItemText
              primary={t('documentation')}
              classes={{
                root: classes.itemTextTop,
                primary: classNames(classes.itemTextPrimaryTop, {
                  [classes.isDark]: isDark
                }),
              }}
            />}
          </ListItem>
        </Tooltip>
        <Tooltip
          isLight
          enabled={!docked}
          enterDelay={config.TOOLTIP_DELAY}
          title={t('documentationApi')}
          disableFocusListener={true}
          placement="right"
        >
          <ListItem
            button
            component={Link}
            to="/publisher/api/description"
            classes={{
              root: classes.menuItemLink,
            }}
          >
            <ListItemIcon classes={{
              root: classNames({
                [classes.menuItemIcon]: !docked && !isMobile,
                [classes.dockedMenuItemIcon]: docked && !isMobile,
              })
            }}>
              <InsertDriveFileOutlinedIcon />
            </ListItemIcon>
            {(docked || isMobile) && <ListItemText
              primary={t('documentationApi')}
              classes={{
                root: classes.itemTextTop,
                primary: classNames(classes.itemTextPrimaryTop, {
                  [classes.isDark]: isDark
                }),
              }}
            />}
          </ListItem>
        </Tooltip>
      </List>
    </div>
  )
}
